import { render, staticRenderFns } from "./ProfessionTaskLinks.vue?vue&type=template&id=641b6f47&scoped=true"
import script from "./ProfessionTaskLinks.vue?vue&type=script&lang=js"
export * from "./ProfessionTaskLinks.vue?vue&type=script&lang=js"
import style0 from "./ProfessionTaskLinks.vue?vue&type=style&index=0&id=641b6f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b6f47",
  null
  
)

export default component.exports